<div class="grid-x grid-padding-x">
  <div class="auto cell">
    <h2>Billing</h2>
    <rav-message id="billing-card"></rav-message>
    <rav-message id="billing-plan"></rav-message>
    <hr />
  </div>
</div>

<div class="grid-x grid-padding-x">
  <div class="cell large-8">
    <div class="grid-x align-middle margin-bottom-1">
      <div class="small-12 medium-shrink cell"><h3>Subscription Plans</h3></div>
      <div class="small-12 medium-auto cell text-center">
        <div class="grid-x align-middle">
          <div class="auto cell text-right margin-right-1">Monthly</div>
          <div class="shrink cell">
            <div class="switch margin-0">
              <input
                [(ngModel)]="isAnnualSwitch"
                class="switch-input"
                id="isAnnual"
                type="checkbox"
                name="Annual Switch"
                checked
              />
              <label class="switch-paddle switch-paddle--always-active" for="isAnnual">
                <span class="show-for-sr">is billed annually</span>
              </label>
            </div>
          </div>
          <div class="auto cell text-left margin-left-1">Annually</div>
        </div>
      </div>
    </div>

    <div class="scroll-container">
      <table class="pricing-table">
        <thead>
          <tr>
            <td>Features</td>
            <td class="text-center" *ngFor="let plan of cloudPlans">
              <h4 class="pricing-table__plan">{{ plan.fields.planName }}</h4>
              <div class="pricing-table__price">
                {{ (isAnnualSwitch ? plan.fields.yearlyPrice / 12 : plan.fields.monthlyPrice) | currency }}/mo
              </div>
              <small class="pricing-table__frequency">Billed {{ isAnnualSwitch ? 'Annually' : 'Monthly' }}</small>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let feature of allFeatures">
            <td>{{ feature }}</td>
            <td class="text-center" *ngFor="let planFeature of planFeatures">
              <i *ngIf="planFeature.includes(feature)" class="fa fa-check success-color"></i>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td>
              <button
                (click)="
                  modal.open.next({
                    modalId: 'plan-selection',
                    selectedPlan: isAnnualSwitch ? 'basic.annually' : 'basic.monthly'
                  })
                "
                [disabled]="
                  account.details && (account.details.subscription_plan | subscriptionButton: 'basic') === 'Current'
                "
                type="button"
                class="expanded hollow button margin-0"
              >
                {{ account.details && account.details.subscription_plan | subscriptionButton: 'basic' }}
              </button>
            </td>
            <td>
              <button
                (click)="
                  modal.open.next({
                    modalId: 'plan-selection',
                    selectedPlan: isAnnualSwitch ? 'pro.annually' : 'pro.monthly'
                  })
                "
                type="button"
                [disabled]="
                  account.details && (account.details.subscription_plan | subscriptionButton: 'pro') === 'Current'
                "
                class="expanded secondary button margin-0"
              >
                {{ account.details && account.details.subscription_plan | subscriptionButton: 'pro' }}
              </button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
  <div class="cell cell large-4">
    <div *ngIf="!!account.details" class="callout subscription" data-cy="current-plan">
      <h4>Your Subscription Plan</h4>
      <div class="stat">
        <i class="fa fa-cloud"></i>
        {{ account.details && account.details.subscription_plan | subscriptionPlan }}
      </div>
      <div>{{ planMessage() }}</div>
      <a *ngIf="canResume()" (click)="resumeSubscription()" class="success-color">Resume</a>
      <a *ngIf="canCancel()" (click)="cancelSubscription()" class="alert-color">Cancel</a>
    </div>

    <div *ngIf="!!account.details" class="callout payment">
      <h4>Your Payment Method</h4>
      <rav-payment-method [account]="account.details"></rav-payment-method>
      <a (click)="modal.open.next({ modalId: 'payment' })">
        {{ account.details.card_last_four ? 'Change' : 'Add' }} Card
      </a>
    </div>
  </div>
</div>

<div class="grid-x grid-padding-x">
  <div class="auto cell">
    <hr />
    <rav-invoices></rav-invoices>
  </div>
</div>

<rav-payment></rav-payment>
<rav-plan-selection [plans]="cloudPlans" [account]="account.details"></rav-plan-selection>
